import React, { MouseEvent, useEffect, useState } from 'react';
import { getUrl, formatPrice } from '../../../../../../../../Foundation/Common/code/Helpers/FormatHelper.ts';
import ProductFavoriteButton from '../../../../../../../../Foundation/React/code/Components/ProductFavoriteButton';
import { sendRecommendationClickEvent } from './Analytics.ts';
import { KlevuRecord } from '@klevu/core';

interface SliderProductProps {
  product: KlevuRecord;
  favorites: string[];
  position: number;
}

export default function SliderProduct({ product, favorites, position }: SliderProductProps) {
  const translations = window._THULEDATA._siteHeader.Translations;
  const price = parseFloat(product.price);
  const salePrice = parseFloat(product.salePrice);

  const [hasDiscount, setHasDiscount] = useState<boolean>(false);

  useEffect(() => {
    if (product.salePrice && salePrice < price && salePrice > 0) {
      setHasDiscount(true);
    } else {
      setHasDiscount(false);
    }
  }, []);

  const onClickTracking = (event: MouseEvent) => {
    sendRecommendationClickEvent('select_recs_list', product, position);
    window.google?.productlistingevents?.addClickedProductsToDataLayer?.(event.target);
  };

  return (
    <div
      className="productSliderItem"
      data-erpoutdoor={product.erp_outdoor}
      data-productstatus="Sellable"
      data-productname={product.displaytitle}
      data-productid={product.id}
    >
      <ProductFavoriteButton productName={product.displayTitle} productId={product.id} favoriteIds={favorites} />
      <span
        className="d-none analytics-data"
        data-currency={product.currency}
        data-name={product.displaytitle}
        data-price={product.price}
        data-pimid={product.id}
        data-position={position}
        data-listname="Similar products"
        data-sku={product.sku}
      ></span>

      <a
        href={getUrl(product.url)}
        className="tag-manager-product-slider-item no-tracking"
        style={{ pointerEvents: 'auto' }}
        onClick={onClickTracking}
      >
        <div className="image-container">
          {product.image.split(',')[0] && (
            <img
              src={product.image.split(',')[0]}
              alt={product.displaytitle}
              width="400"
              height="300"
              className="lozad"
              loading="lazy"
              data-loaded="true"
            />
          )}
        </div>
        <div className="heading6 mt-5">{product.displaytitle}</div>
        {product.name && <div className="paragraph--s description mt-2 text--truncate-3">{product.name}</div>}
        {price !== 0 && (
          <div className="price mt-2">
            <span className="price mb-0">
              {hasDiscount && (
                <>
                  <span className="visually-hidden">{translations.SalePrice}</span>
                  <span
                    className="discount-price-value me-2"
                    data-defaultprice={formatPrice(product.salePrice, product.currency)}
                  >
                    {formatPrice(product.salePrice, product.currency)}
                  </span>
                  <span className="visually-hidden">{translations.OriginalPrice}</span>
                </>
              )}
              <span
                className={`price-value ${hasDiscount ? 'discounted' : ''}`}
                data-defaultprice={formatPrice(product.price, product.currency)}
              >
                {formatPrice(product.price, product.currency)}
              </span>
              {hasDiscount && (
                <div className="discount-price--saved d-block">
                  ({translations.Save} {formatPrice(String(price - salePrice), product.currency)})
                </div>
              )}
              <span className="d-none ga-price">{product.price.replace(product.currency, '').trim()}</span>
              {hasDiscount && product.price && (
                <span className="d-none ga-discount-price">
                  {product.salePrice.replace(product.currency, '').trim()}
                </span>
              )}
              <span className="d-none currencycode">{product.currency}</span>
              <span className="d-none ga-minimum-price-rrp"></span>
              <span className="d-none ga-minimum-discount-price-rrp"></span>
            </span>
          </div>
        )}
      </a>
    </div>
  );
}
